import { render, staticRenderFns } from "./CreatePageSpecificQuestion.vue?vue&type=template&id=9c10151a"
import script from "./CreatePageSpecificQuestion.vue?vue&type=script&lang=ts"
export * from "./CreatePageSpecificQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports